module.exports = __webpack_public_path__ + "media/numbers/two-653c2c2f.svg";